import React, { useMemo } from 'react';
import SteamHourlyAddedReviews from '../../../component/SteamHourlyAddedReviews';
import { IRealtimeSteamPerformance } from '../../../type';
import SteamAllReviews from '../../../component/SteamAllReviews';

export default function SteamPerformanceChart(props: IRealtimeSteamPerformance) {
  const { tab, filter, timelineData, ...restProps } = props;
  const { steamData, addedReviews, databrainData } = timelineData || {};

  if (tab === 'steam_all') {
    return (
      <SteamAllReviews {...restProps} filter={filter} timelineData={steamData} />
    );
  }

  if (tab === 'all') {
    return (
      <SteamHourlyAddedReviews {...restProps} filter={filter} timelineData={databrainData} tab={tab} height={376} tableHeight={334.5} />
    );
  }

  return (
    <SteamHourlyAddedReviews {...restProps} filter={filter} timelineData={addedReviews} height={376} tableHeight={334.5} />
  );
}